import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../common/Card';
import Button from '../common/Button';
import { theme } from '../../config/theme';
import { formatCurrency } from '../../utils/helpers';

const CartSummary = ({ summary, onClearCart, loading }) => {
  const navigate = useNavigate();

  const rowStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing.md,
    fontSize: theme.typography.fontSize.sm,
  };

  const totalRowStyles = {
    ...rowStyles,
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.bold,
    paddingTop: theme.spacing.md,
    borderTop: `2px solid ${theme.colors.gray[200]}`,
  };

  return (
    <Card padding="lg">
      <h3 style={{ 
        fontSize: theme.typography.fontSize.lg, 
        fontWeight: theme.typography.fontWeight.semibold,
        marginBottom: theme.spacing.lg,
      }}>
        Order Summary
      </h3>

      <div style={rowStyles}>
        <span style={{ color: theme.colors.text.secondary }}>
          Items ({summary.itemCount})
        </span>
        <span>{summary.totalItems} items</span>
      </div>

      <div style={totalRowStyles}>
        <span>Subtotal</span>
        <span style={{ color: theme.colors.primary.main }}>
          {formatCurrency(summary.subtotal)}
        </span>
      </div>

      <Button 
        variant="primary"
        size="lg"
        fullWidth 
        onClick={() => navigate('/checkout')}
        disabled={loading || summary.itemCount === 0}
        style={{ marginTop: theme.spacing.lg, marginBottom: theme.spacing.md }}
      >
        Proceed to Checkout
      </Button>

      <Button 
        variant="secondary"
        size="sm"
        fullWidth 
        onClick={onClearCart}
        disabled={loading || summary.itemCount === 0}
      >
        Clear Cart
      </Button>

      <div style={{
        marginTop: theme.spacing.lg,
        padding: theme.spacing.md,
        backgroundColor: theme.colors.gray[50],
        borderRadius: theme.borderRadius.md,
        fontSize: theme.typography.fontSize.xs,
        color: theme.colors.text.secondary,
        textAlign: 'center',
      }}>
        Taxes and shipping calculated at checkout
      </div>
    </Card>
  );
};

export default CartSummary;